import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2 m-3"
}
const _hoisted_2 = {
  key: 1,
  class: "wl-kpis"
}
const _hoisted_3 = { class: "wl-stat wl-stat--dark" }
const _hoisted_4 = { class: "wl-stat__head" }
const _hoisted_5 = { class: "wl-stat__title" }
const _hoisted_6 = { class: "wl-stat__value" }
const _hoisted_7 = { class: "wl-stat__meta" }
const _hoisted_8 = { class: "wl-stat" }
const _hoisted_9 = { class: "wl-stat__head" }
const _hoisted_10 = { class: "wl-stat__title" }
const _hoisted_11 = { class: "wl-stat__value" }
const _hoisted_12 = { class: "wl-stat__meta" }
const _hoisted_13 = { class: "assets-grid-card" }
const _hoisted_14 = { class: "assets-grid-card__header" }
const _hoisted_15 = { class: "assets-grid-title" }
const _hoisted_16 = { class: "assets-grid-title__text" }
const _hoisted_17 = { class: "assets-grid-card__body" }
const _hoisted_18 = { class: "wl-assets-search-wrap" }
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = {
  key: 0,
  class: "wp-grid-wrap"
}
const _hoisted_21 = {
  key: 0,
  class: "wp-loading wp-loading--overlay"
}
const _hoisted_22 = { class: "wp-loading__text" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 0,
  class: "text-muted small"
}
const _hoisted_25 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_26 = { class: "text-muted small font-monospace" }
const _hoisted_27 = ["title"]
const _hoisted_28 = {
  key: 1,
  class: "text-muted small font-monospace"
}
const _hoisted_29 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_30 = { class: "text-muted small font-monospace" }
const _hoisted_31 = { class: "text-muted small font-monospace" }
const _hoisted_32 = { class: "text-muted small font-monospace" }
const _hoisted_33 = {
  key: 0,
  class: "wl-row-actions"
}
const _hoisted_34 = ["title", "onClick"]
const _hoisted_35 = { class: "assets-grid-card ni-grid-card--spaced" }
const _hoisted_36 = { class: "assets-grid-card__header" }
const _hoisted_37 = { class: "assets-grid-title" }
const _hoisted_38 = { class: "assets-grid-title__text" }
const _hoisted_39 = { class: "assets-grid-controls" }
const _hoisted_40 = { class: "assets-grid-card__body" }
const _hoisted_41 = { class: "wl-assets-search-wrap" }
const _hoisted_42 = ["placeholder"]
const _hoisted_43 = {
  key: 0,
  class: "wp-grid-wrap"
}
const _hoisted_44 = {
  key: 0,
  class: "wp-loading wp-loading--overlay"
}
const _hoisted_45 = { class: "wp-loading__text" }
const _hoisted_46 = { class: "font-monospace small" }
const _hoisted_47 = {
  key: 0,
  class: "ni-anchor-gw-list"
}
const _hoisted_48 = ["onClick"]
const _hoisted_49 = ["title"]
const _hoisted_50 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_51 = { class: "text-muted small font-monospace" }
const _hoisted_52 = { class: "text-muted small font-monospace" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[5] || (_cache[5] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.error), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.statsLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('components.infrastructure.kpis.gatewaysActive')), 1),
              _cache[6] || (_cache[6] = _createElementVNode("i", { class: "bi bi-hdd-network wl-stat__icon" }, null, -1))
            ]),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.stats.gatewaysActive) + "/" + _toDisplayString(_ctx.stats.gatewaysTotal), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('components.infrastructure.kpis.gatewaysActiveMeta')), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('components.infrastructure.kpis.anchorsActive')), 1),
              _cache[7] || (_cache[7] = _createElementVNode("i", {
                class: "bi bi-broadcast wl-stat__icon",
                style: {"color":"#3f8f52"}
              }, null, -1))
            ]),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.stats.anchorsActive) + "/" + _toDisplayString(_ctx.stats.anchorsTotal), 1),
            _createElementVNode("div", {
              class: "wl-stat__accent",
              style: _normalizeStyle({ width: _ctx.stats.anchorsTotal ? `${(_ctx.stats.anchorsActive / _ctx.stats.anchorsTotal) * 100}%` : '0%', background: '#3f8f52' })
            }, null, 4),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('components.infrastructure.kpis.anchorsActiveMeta')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "assets-grid-title__icon" }, [
            _createElementVNode("i", { class: "bi bi-hdd-network" })
          ], -1)),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('components.infrastructure.gateways.title')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.gatewaySearch) = $event)),
            type: "text",
            class: "form-control wl-assets-search",
            placeholder: _ctx.$t('components.infrastructure.gateways.searchPlaceholder'),
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onGatewaySearchInput && _ctx.onGatewaySearchInput(...args)))
          }, null, 40, _hoisted_19), [
            [_vModelText, _ctx.gatewaySearch]
          ])
        ]),
        (_ctx.hasActivated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              (_ctx.gatewaysLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _cache[9] || (_cache[9] = _createElementVNode("span", {
                      class: "spinner-border wp-loading__spinner",
                      role: "status"
                    }, null, -1)),
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('components.infrastructure.loading')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_DxDataGrid, {
                ref: "gatewaysGridRef",
                class: "ni-grid",
                "data-source": _ctx.gatewaysDataSource,
                "remote-operations": true,
                "key-expr": "gwId",
                "hover-state-enabled": true,
                "column-auto-width": false,
                "show-borders": false,
                "show-column-lines": false,
                "show-row-lines": false,
                "row-alternation-enabled": true,
                "column-hiding-enabled": _ctx.isNarrowViewport,
                "word-wrap-enabled": false,
                "no-data-text": _ctx.$t('components.infrastructure.gateways.empty'),
                onRowClick: _ctx.onGatewayRowClick
              }, {
                "loc-template": _withCtx(({ data }) => [
                  (data.data.locationName)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                        _createTextVNode(_toDisplayString(data.data.locationName) + " ", 1),
                        (data.data.locationCity)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, " · " + _toDisplayString(data.data.locationCity), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t('components.infrastructure.gateways.unassigned')), 1))
                ]),
                "gwid-template": _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_26, _toDisplayString(data.data.gwId), 1)
                ]),
                "sinks-template": _withCtx(({ data }) => [
                  (data.data.sinkIds && data.data.sinkIds.length)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "text-muted small font-monospace",
                        title: data.data.sinkIds.join(', ')
                      }, _toDisplayString(data.data.sinkIds.join(', ')), 9, _hoisted_27))
                    : (data.data.sinkCount)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(data.data.sinkCount), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_29, "—"))
                ]),
                "updated-template": _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.agoText(data.data.updatedAt)), 1)
                ]),
                "msgcount-template": _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_31, _toDisplayString(Number(data.data.messageCount ?? 0).toLocaleString('pl-PL')), 1)
                ]),
                "lastasset-template": _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.agoText(data.data.lastAssetSeen)), 1)
                ]),
                "gwstatus-template": _withCtx(({ data }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass(["wirepas-status-badge", data.data.state === 'online' ? 'wirepas-status-badge--online' : 'wirepas-status-badge--offline'])
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["wirepas-status-dot", data.data.state === 'online' ? 'wirepas-status-dot--online' : 'wirepas-status-dot--offline'])
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(data.data.state === 'online' ? _ctx.$t('components.infrastructure.online') : _ctx.$t('components.infrastructure.offline')), 1)
                  ], 2)
                ]),
                "gw-actions-template": _withCtx(({ data }) => [
                  (data.data.assignedLocationId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "wl-row-action",
                          title: _ctx.$t('components.infrastructure.gateways.showLocation'),
                          onClick: _withModifiers(($event: any) => (_ctx.$router.push(`/wirepas-locations/${data.data.assignedLocationId}/detail`)), ["stop"])
                        }, [...(_cache[10] || (_cache[10] = [
                          _createElementVNode("i", { class: "bi bi-eye" }, null, -1)
                        ]))], 8, _hoisted_34)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_DxLoadPanel, { enabled: false }),
                  _createVNode(_component_DxPaging, { "page-size": 10 }),
                  _createVNode(_component_DxPager, {
                    "allowed-page-sizes": [10, 20, 50],
                    "show-info": true,
                    "show-page-size-selector": true,
                    "show-navigation-buttons": true
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "locationName",
                    caption: _ctx.$t('components.infrastructure.gateways.columns.location'),
                    "min-width": 220,
                    "allow-sorting": false,
                    "cell-template": "loc-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "gwId",
                    caption: _ctx.$t('components.infrastructure.gateways.columns.gwId'),
                    width: "150",
                    "allow-sorting": false,
                    "cell-template": "gwid-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "gatewayModel",
                    caption: _ctx.$t('components.infrastructure.gateways.columns.model'),
                    width: "140",
                    "allow-sorting": false
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "sinkIds",
                    caption: _ctx.$t('components.infrastructure.gateways.columns.sinks'),
                    width: "100",
                    "allow-sorting": false,
                    "cell-template": "sinks-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "assetCount",
                    caption: _ctx.$t('components.infrastructure.gateways.columns.assetCount'),
                    width: "125",
                    alignment: "center",
                    "allow-sorting": false
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "messageCount",
                    caption: _ctx.$t('components.infrastructure.gateways.columns.messageCount'),
                    width: "125",
                    alignment: "center",
                    "allow-sorting": false,
                    "cell-template": "msgcount-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "lastAssetSeen",
                    caption: _ctx.$t('components.infrastructure.gateways.columns.lastAssetSeen'),
                    width: "165",
                    "allow-sorting": false,
                    "cell-template": "lastasset-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "updatedAt",
                    caption: _ctx.$t('components.infrastructure.gateways.columns.updatedAt'),
                    width: "250",
                    "allow-sorting": false,
                    "cell-template": "updated-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "state",
                    caption: _ctx.$t('components.infrastructure.gateways.columns.status'),
                    width: "120",
                    alignment: "center",
                    "allow-sorting": false,
                    "cell-template": "gwstatus-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    caption: _ctx.$t('components.assetGroupsWithLocation.columns.actions'),
                    width: "100",
                    "allow-filtering": false,
                    "allow-sorting": false,
                    "cell-template": "gw-actions-template"
                  }, null, 8, ["caption"])
                ]),
                _: 1
              }, 8, ["data-source", "column-hiding-enabled", "no-data-text", "onRowClick"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "assets-grid-title__icon" }, [
            _createElementVNode("i", { class: "bi bi-broadcast" })
          ], -1)),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t('components.infrastructure.anchors.title')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          (_ctx.selectedGwId)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "assets-toolbar-btn",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearGatewayFilter && _ctx.clearGatewayFilter(...args)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.infrastructure.anchors.filterLabel')) + ": " + _toDisplayString(_ctx.shortGwId(_ctx.selectedGwId)), 1),
                _cache[12] || (_cache[12] = _createElementVNode("i", { class: "bi bi-x-lg" }, null, -1))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.anchorSearch) = $event)),
            type: "text",
            class: "form-control wl-assets-search",
            placeholder: _ctx.$t('components.infrastructure.anchors.searchPlaceholder'),
            onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onAnchorSearchInput && _ctx.onAnchorSearchInput(...args)))
          }, null, 40, _hoisted_42), [
            [_vModelText, _ctx.anchorSearch]
          ])
        ]),
        (_ctx.hasActivated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
              (_ctx.anchorsLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _cache[13] || (_cache[13] = _createElementVNode("span", {
                      class: "spinner-border wp-loading__spinner",
                      role: "status"
                    }, null, -1)),
                    _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t('components.infrastructure.loading')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_DxDataGrid, {
                ref: "anchorsGridRef",
                class: "ni-grid",
                "data-source": _ctx.anchorsDataSource,
                "remote-operations": true,
                "key-expr": "address",
                "hover-state-enabled": true,
                "column-auto-width": false,
                "show-borders": false,
                "show-column-lines": false,
                "show-row-lines": false,
                "row-alternation-enabled": true,
                "column-hiding-enabled": _ctx.isNarrowViewport,
                "word-wrap-enabled": true,
                "no-data-text": _ctx.selectedGwId ? _ctx.$t('components.infrastructure.anchors.emptyFiltered') : _ctx.$t('components.infrastructure.anchors.empty')
              }, {
                "addr-template": _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_46, _toDisplayString(data.data.address), 1)
                ]),
                "anchor-gw-template": _withCtx(({ data }) => [
                  (data.data.gateways && data.data.gateways.length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.data.gateways.slice(0, 2), (gw) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: gw,
                            class: _normalizeClass(["ni-anchor-gw", { 'ni-anchor-gw--selected': _ctx.selectedGwId === gw }]),
                            onClick: _withModifiers(($event: any) => (_ctx.onAnchorGwClick(gw)), ["stop"])
                          }, _toDisplayString(gw), 11, _hoisted_48))
                        }), 128)),
                        (data.data.gateways.length > 2)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "text-muted small",
                              title: data.data.gateways.slice(2).join(', ')
                            }, "+" + _toDisplayString(data.data.gateways.length - 2), 9, _hoisted_49))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_50, "—"))
                ]),
                "rssi-template": _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_51, _toDisplayString(data.data.lastRssiDbm != null ? `${data.data.lastRssiDbm} dBm` : '—'), 1)
                ]),
                "anchor-updated-template": _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.agoText(data.data.lastSeen)), 1)
                ]),
                "anchor-status-template": _withCtx(({ data }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass(["wirepas-status-badge", data.data.active ? 'wirepas-status-badge--online' : 'wirepas-status-badge--offline'])
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["wirepas-status-dot", data.data.active ? 'wirepas-status-dot--online' : 'wirepas-status-dot--offline'])
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(data.data.active ? _ctx.$t('components.infrastructure.anchors.status.active') : _ctx.$t('components.infrastructure.anchors.status.silent')), 1)
                  ], 2)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_DxLoadPanel, { enabled: false }),
                  _createVNode(_component_DxPaging, { "page-size": 10 }),
                  _createVNode(_component_DxPager, {
                    "allowed-page-sizes": [10, 20, 50],
                    "show-info": true,
                    "show-page-size-selector": true,
                    "show-navigation-buttons": true
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "address",
                    caption: _ctx.$t('components.infrastructure.anchors.columns.address'),
                    "min-width": 150,
                    "allow-sorting": false,
                    "cell-template": "addr-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "gateways",
                    caption: _ctx.$t('components.infrastructure.anchors.columns.gateway'),
                    "min-width": 200,
                    "allow-sorting": false,
                    "cell-template": "anchor-gw-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "tagsHeard",
                    caption: _ctx.$t('components.infrastructure.anchors.columns.tagsHeard'),
                    "min-width": 110,
                    alignment: "center",
                    "allow-sorting": false,
                    "hiding-priority": 1
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "lastRssiDbm",
                    caption: _ctx.$t('components.infrastructure.anchors.columns.lastRssi'),
                    "min-width": 110,
                    alignment: "center",
                    "allow-sorting": false,
                    "cell-template": "rssi-template",
                    "hiding-priority": 2
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "lastSeen",
                    caption: _ctx.$t('components.infrastructure.anchors.columns.lastSeen'),
                    "min-width": 140,
                    "allow-sorting": false,
                    "cell-template": "anchor-updated-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "active",
                    caption: _ctx.$t('components.infrastructure.anchors.columns.status'),
                    "min-width": 110,
                    alignment: "center",
                    "allow-sorting": false,
                    "cell-template": "anchor-status-template"
                  }, null, 8, ["caption"])
                ]),
                _: 1
              }, 8, ["data-source", "column-hiding-enabled", "no-data-text"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}